import "./sentry-instrument";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

const container = document.getElementById("root") || document.getElementById("app");

if (!container) {
  throw new Error("Root element not found for React app");
}

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
